import { useState, useRef, useEffect } from 'react';

// SSR (no IntersectionObserver) defaults inView=true so content is never gated off.
// Test stubs keep it false — gate only optional work (fetch `skip`) on inView, never the render.
export const useInView = ({ rootMargin = '200px' } = {}) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(() => typeof IntersectionObserver === 'undefined');

  useEffect(() => {
    if (inView) return undefined;
    const node = ref.current;
    if (!node || typeof IntersectionObserver === 'undefined') return undefined;

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        setInView(true);
        observer.disconnect();
      }
    }, { rootMargin, threshold: 0 });

    observer.observe(node);
    return () => observer.disconnect();
  }, [inView, rootMargin]);

  return { ref, inView };
};
